import { Add } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function AnniversaryBonusEditorPreview() {
    const { t } = useTranslation();
    return <Box
        sx={{
            borderColor: "grey",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "16px",
            padding: "30px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        }}
    >
        <Add /> {t("actionModules.subtypes.anniversaryBonus.previewSelectVoucher")}
    </Box>;
}